export const readUrl = (url)=>{
    return new Promise((resolve,reject)=>{
        fetch(url)
        .then((response) => response.text())
        .then((textContent) => {
            resolve(textContent);
        });
    });
}